import { render } from "./slideTwo.vue?vue&type=template&id=04fc5b5e"
import script from "./slideTwo.vue?vue&type=script&lang=js"
export * from "./slideTwo.vue?vue&type=script&lang=js"

import "./slideTwo.vue?vue&type=style&index=0&id=04fc5b5e&lang=css"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__